<div class="drugs-by-phase-container">
  <div class="header">
    <div class="chart-title">
      <span>Clinical Phase</span>
    </div>
    <div class="chart-info" *ngIf="chartReady && !showError">
      <span># of Indications</span>
    </div>
  </div>
  <div class="chart-container">
    <nz-spin nzTip="Crunching numbers..." *ngIf="!chartReady" class="spinner">
    </nz-spin>
    <highcharts-chart
      *ngIf="chartReady && !showError"
      [Highcharts]="highcharts"
      [options]="chartOptions"
      [(update)]="updateFlag"
      style="width: 100%; height: 100%;display: block;"
      [ngClass]=""
    >
    </highcharts-chart>
    <div id="charts-error" class="error-container" *ngIf="showError">
      <div class="error-msg">
        <va-icon name="info-circle" class="info-icon"></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </div>
</div>
